'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var commons = {
    cancelRequestMessage: 'ARC: Cancel request due to unmount'
};
exports.default = commons;